import { connectionStatusView } from '$comp/main/root.reducer'
import { dispatchSetConnectionStatus } from '$comp/main/root.action'
import { sendSocketDisconnectedEventToWapps } from '$logic/wapp-subscribed-topics'
import { createCallbackManager } from '$func/callbacks'
import { setMessagesAreSynced } from '$logic/message'

export const disconnectionCallbackManager = createCallbackManager()

export default () => {
  // NOTE: To avoid sending multiple disconnection events to wapps
  // NOTE: Call order is IMPORTANT! DO NOT MODIFY!
  if (connectionStatusView() !== 'connecting')
    sendSocketDisconnectedEventToWapps()

  setMessagesAreSynced(false)
  dispatchSetConnectionStatus('connecting')
  disconnectionCallbackManager.runCallbacks()
}
